module.exports = __webpack_public_path__ + "img/glassquality_6.39193d9e.png";